import React from 'react';

import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import CurrencyColumn from '../../../components/columns/currency-column';
import { useIsFulfillmentPlanThirdPartyBilling } from '../../../fulfillment-planner/hooks/use-is-fulfillment-plan-third-party-billing';
import Global from '../../../store/global-selectors';
import { messages } from '../messages';

const RateColumn = ({ fulfillmentId }) => {
  const { fulfillmentPlanId } = useSelector((state) => Global.selectEntitiesFulfillmentById(state, { fulfillmentId })) ?? {};
  const { rate } =
    useSelector((state) =>
      Global.selectEntitiesFulfillmentPlanProperty(state, {
        fulfillmentPlanId,
        property: 'rateSummary',
      }),
    ) ?? {};
  const { serviceId, options } =
    useSelector((state) =>
      Global.selectEntitiesFulfillmentPlanProperty(state, {
        fulfillmentPlanId,
        property: 'labelConfiguration',
      }),
    ) ?? {};
  const isThirdPartyBilling = useIsFulfillmentPlanThirdPartyBilling(serviceId, options);

  if (!rate?.totalCost || isThirdPartyBilling) {
    return '';
  }

  const { value, code } = rate.totalCost;

  return <CurrencyColumn currencyCode={code} value={value} />;
};

RateColumn.propTypes = {
  fulfillmentId: PropTypes.string.isRequired,
};

export const Rate = {
  getMessageDescriptor: () => messages.rate,
  id: 'rate',

  render: (data) => {
    if (!data) {
      return '';
    }
    return <RateColumn fulfillmentId={data.id} />;
  },
};
